export default {
  en: [
    { text: 'Switzerland', value: 'CH' },
    { text: 'Germany', value: 'DE' },
    { text: 'Austria', value: 'AT' },
    { text: 'Liechtenstein', value: 'LI' },
    { text: 'Afghanistan', value: 'AF' },
    { text: 'Åland Islands', value: 'AX' },
    { text: 'Albania', value: 'AL' },
    { text: 'Algeria', value: 'DZ' },
    { text: 'American Samoa', value: 'AS' },
    { text: 'AndorrA', value: 'AD' },
    { text: 'Angola', value: 'AO' },
    { text: 'Anguilla', value: 'AI' },
    { text: 'Antarctica', value: 'AQ' },
    { text: 'Antigua and Barbuda', value: 'AG' },
    { text: 'Argentina', value: 'AR' },
    { text: 'Armenia', value: 'AM' },
    { text: 'Aruba', value: 'AW' },
    { text: 'Australia', value: 'AU' },
    { text: 'Azerbaijan', value: 'AZ' },
    { text: 'Bahamas', value: 'BS' },
    { text: 'Bahrain', value: 'BH' },
    { text: 'Bangladesh', value: 'BD' },
    { text: 'Barbados', value: 'BB' },
    { text: 'Belarus', value: 'BY' },
    { text: 'Belgium', value: 'BE' },
    { text: 'Belize', value: 'BZ' },
    { text: 'Benin', value: 'BJ' },
    { text: 'Bermuda', value: 'BM' },
    { text: 'Bhutan', value: 'BT' },
    { text: 'Bolivia', value: 'BO' },
    { text: 'Bosnia and Herzegovina', value: 'BA' },
    { text: 'Botswana', value: 'BW' },
    { text: 'Bouvet Island', value: 'BV' },
    { text: 'Brazil', value: 'BR' },
    { text: 'British Indian Ocean Territory', value: 'IO' },
    { text: 'Brunei Darussalam', value: 'BN' },
    { text: 'Bulgaria', value: 'BG' },
    { text: 'Burkina Faso', value: 'BF' },
    { text: 'Burundi', value: 'BI' },
    { text: 'Cambodia', value: 'KH' },
    { text: 'Cameroon', value: 'CM' },
    { text: 'Canada', value: 'CA' },
    { text: 'Cape Verde', value: 'CV' },
    { text: 'Cayman Islands', value: 'KY' },
    { text: 'Central African Republic', value: 'CF' },
    { text: 'Chad', value: 'TD' },
    { text: 'Chile', value: 'CL' },
    { text: 'China', value: 'CN' },
    { text: 'Christmas Island', value: 'CX' },
    { text: 'Cocos (Keeling) Islands', value: 'CC' },
    { text: 'Colombia', value: 'CO' },
    { text: 'Comoros', value: 'KM' },
    { text: 'Congo', value: 'CG' },
    { text: 'Congo, The Democratic Republic of the', value: 'CD' },
    { text: 'Cook Islands', value: 'CK' },
    { text: 'Costa Rica', value: 'CR' },
    { text: "Cote D'Ivoire", value: 'CI' },
    { text: 'Croatia', value: 'HR' },
    { text: 'Cuba', value: 'CU' },
    { text: 'Cyprus', value: 'CY' },
    { text: 'Czech Republic', value: 'CZ' },
    { text: 'Denmark', value: 'DK' },
    { text: 'Djibouti', value: 'DJ' },
    { text: 'Dominica', value: 'DM' },
    { text: 'Dominican Republic', value: 'DO' },
    { text: 'Ecuador', value: 'EC' },
    { text: 'Egypt', value: 'EG' },
    { text: 'El Salvador', value: 'SV' },
    { text: 'Equatorial Guinea', value: 'GQ' },
    { text: 'Eritrea', value: 'ER' },
    { text: 'Estonia', value: 'EE' },
    { text: 'Ethiopia', value: 'ET' },
    { text: 'Falkland Islands (Malvinas)', value: 'FK' },
    { text: 'Faroe Islands', value: 'FO' },
    { text: 'Fiji', value: 'FJ' },
    { text: 'Finland', value: 'FI' },
    { text: 'France', value: 'FR' },
    { text: 'French Guiana', value: 'GF' },
    { text: 'French Polynesia', value: 'PF' },
    { text: 'French Southern Territories', value: 'TF' },
    { text: 'Gabon', value: 'GA' },
    { text: 'Gambia', value: 'GM' },
    { text: 'Georgia', value: 'GE' },
    { text: 'Ghana', value: 'GH' },
    { text: 'Gibraltar', value: 'GI' },
    { text: 'Greece', value: 'GR' },
    { text: 'Greenland', value: 'GL' },
    { text: 'Grenada', value: 'GD' },
    { text: 'Guadeloupe', value: 'GP' },
    { text: 'Guam', value: 'GU' },
    { text: 'Guatemala', value: 'GT' },
    { text: 'Guernsey', value: 'GG' },
    { text: 'Guinea', value: 'GN' },
    { text: 'Guinea-Bissau', value: 'GW' },
    { text: 'Guyana', value: 'GY' },
    { text: 'Haiti', value: 'HT' },
    { text: 'Heard Island and Mcdonald Islands', value: 'HM' },
    { text: 'Holy See (Vatican City State)', value: 'VA' },
    { text: 'Honduras', value: 'HN' },
    { text: 'Hong Kong', value: 'HK' },
    { text: 'Hungary', value: 'HU' },
    { text: 'Iceland', value: 'IS' },
    { text: 'India', value: 'IN' },
    { text: 'Indonesia', value: 'ID' },
    { text: 'Iran, Islamic Republic Of', value: 'IR' },
    { text: 'Iraq', value: 'IQ' },
    { text: 'Ireland', value: 'IE' },
    { text: 'Isle of Man', value: 'IM' },
    { text: 'Israel', value: 'IL' },
    { text: 'Italy', value: 'IT' },
    { text: 'Jamaica', value: 'JM' },
    { text: 'Japan', value: 'JP' },
    { text: 'Jersey', value: 'JE' },
    { text: 'Jordan', value: 'JO' },
    { text: 'Kazakhstan', value: 'KZ' },
    { text: 'Kenya', value: 'KE' },
    { text: 'Kiribati', value: 'KI' },
    { text: "Korea, Democratic People'S Republic of", value: 'KP' },
    { text: 'Korea, Republic of', value: 'KR' },
    { text: 'Kuwait', value: 'KW' },
    { text: 'Kyrgyzstan', value: 'KG' },
    { text: "Lao People'S Democratic Republic", value: 'LA' },
    { text: 'Latvia', value: 'LV' },
    { text: 'Lebanon', value: 'LB' },
    { text: 'Lesotho', value: 'LS' },
    { text: 'Liberia', value: 'LR' },
    { text: 'Libyan Arab Jamahiriya', value: 'LY' },
    { text: 'Lithuania', value: 'LT' },
    { text: 'Luxembourg', value: 'LU' },
    { text: 'Macao', value: 'MO' },
    { text: 'Macedonia, The Former Yugoslav Republic of', value: 'MK' },
    { text: 'Madagascar', value: 'MG' },
    { text: 'Malawi', value: 'MW' },
    { text: 'Malaysia', value: 'MY' },
    { text: 'Maldives', value: 'MV' },
    { text: 'Mali', value: 'ML' },
    { text: 'Malta', value: 'MT' },
    { text: 'Marshall Islands', value: 'MH' },
    { text: 'Martinique', value: 'MQ' },
    { text: 'Mauritania', value: 'MR' },
    { text: 'Mauritius', value: 'MU' },
    { text: 'Mayotte', value: 'YT' },
    { text: 'Mexico', value: 'MX' },
    { text: 'Micronesia, Federated States of', value: 'FM' },
    { text: 'Moldova, Republic of', value: 'MD' },
    { text: 'Monaco', value: 'MC' },
    { text: 'Mongolia', value: 'MN' },
    { text: 'Montserrat', value: 'MS' },
    { text: 'Morocco', value: 'MA' },
    { text: 'Mozambique', value: 'MZ' },
    { text: 'Myanmar', value: 'MM' },
    { text: 'Namibia', value: 'NA' },
    { text: 'Nauru', value: 'NR' },
    { text: 'Nepal', value: 'NP' },
    { text: 'Netherlands', value: 'NL' },
    { text: 'Netherlands Antilles', value: 'AN' },
    { text: 'New Caledonia', value: 'NC' },
    { text: 'New Zealand', value: 'NZ' },
    { text: 'Nicaragua', value: 'NI' },
    { text: 'Niger', value: 'NE' },
    { text: 'Nigeria', value: 'NG' },
    { text: 'Niue', value: 'NU' },
    { text: 'Norfolk Island', value: 'NF' },
    { text: 'Northern Mariana Islands', value: 'MP' },
    { text: 'Norway', value: 'NO' },
    { text: 'Oman', value: 'OM' },
    { text: 'Pakistan', value: 'PK' },
    { text: 'Palau', value: 'PW' },
    { text: 'Palestinian Territory, Occupied', value: 'PS' },
    { text: 'Panama', value: 'PA' },
    { text: 'Papua New Guinea', value: 'PG' },
    { text: 'Paraguay', value: 'PY' },
    { text: 'Peru', value: 'PE' },
    { text: 'Philippines', value: 'PH' },
    { text: 'Pitcairn', value: 'PN' },
    { text: 'Poland', value: 'PL' },
    { text: 'Portugal', value: 'PT' },
    { text: 'Puerto Rico', value: 'PR' },
    { text: 'Qatar', value: 'QA' },
    { text: 'Reunion', value: 'RE' },
    { text: 'Romania', value: 'RO' },
    { text: 'Russian Federation', value: 'RU' },
    { text: 'RWANDA', value: 'RW' },
    { text: 'Saint Helena', value: 'SH' },
    { text: 'Saint Kitts and Nevis', value: 'KN' },
    { text: 'Saint Lucia', value: 'LC' },
    { text: 'Saint Pierre and Miquelon', value: 'PM' },
    { text: 'Saint Vincent and the Grenadines', value: 'VC' },
    { text: 'Samoa', value: 'WS' },
    { text: 'San Marino', value: 'SM' },
    { text: 'Sao Tome and Principe', value: 'ST' },
    { text: 'Saudi Arabia', value: 'SA' },
    { text: 'Senegal', value: 'SN' },
    { text: 'Serbia and Montenegro', value: 'CS' },
    { text: 'Seychelles', value: 'SC' },
    { text: 'Sierra Leone', value: 'SL' },
    { text: 'Singapore', value: 'SG' },
    { text: 'Slovakia', value: 'SK' },
    { text: 'Slovenia', value: 'SI' },
    { text: 'Solomon Islands', value: 'SB' },
    { text: 'Somalia', value: 'SO' },
    { text: 'South Africa', value: 'ZA' },
    { text: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { text: 'Spain', value: 'ES' },
    { text: 'Sri Lanka', value: 'LK' },
    { text: 'Sudan', value: 'SD' },
    { text: 'Suritext', value: 'SR' },
    { text: 'Svalbard and Jan Mayen', value: 'SJ' },
    { text: 'Swaziland', value: 'SZ' },
    { text: 'Sweden', value: 'SE' },
    { text: 'Syrian Arab Republic', value: 'SY' },
    { text: 'Taiwan, Province of China', value: 'TW' },
    { text: 'Tajikistan', value: 'TJ' },
    { text: 'Tanzania, United Republic of', value: 'TZ' },
    { text: 'Thailand', value: 'TH' },
    { text: 'Timor-Leste', value: 'TL' },
    { text: 'Togo', value: 'TG' },
    { text: 'Tokelau', value: 'TK' },
    { text: 'Tonga', value: 'TO' },
    { text: 'Trinidad and Tobago', value: 'TT' },
    { text: 'Tunisia', value: 'TN' },
    { text: 'Turkey', value: 'TR' },
    { text: 'Turkmenistan', value: 'TM' },
    { text: 'Turks and Caicos Islands', value: 'TC' },
    { text: 'Tuvalu', value: 'TV' },
    { text: 'Uganda', value: 'UG' },
    { text: 'Ukraine', value: 'UA' },
    { text: 'United Arab Emirates', value: 'AE' },
    { text: 'United Kingdom', value: 'GB' },
    { text: 'United States', value: 'US' },
    { text: 'United States Minor Outlying Islands', value: 'UM' },
    { text: 'Uruguay', value: 'UY' },
    { text: 'Uzbekistan', value: 'UZ' },
    { text: 'Vanuatu', value: 'VU' },
    { text: 'Venezuela', value: 'VE' },
    { text: 'Viet Nam', value: 'VN' },
    { text: 'Virgin Islands, British', value: 'VG' },
    { text: 'Virgin Islands, U.S.', value: 'VI' },
    { text: 'Wallis and Futuna', value: 'WF' },
    { text: 'Western Sahara', value: 'EH' },
    { text: 'Yemen', value: 'YE' },
    { text: 'Zambia', value: 'ZM' },
    { text: 'Zimbabwe', value: 'ZW' },
  ],
  de: [
    { text: 'Schweiz', value: 'CH' },
    { text: 'Deutschland', value: 'DE' },
    { text: 'Österreich', value: 'AT' },
    { text: 'Liechtenstein', value: 'LI' },
    { text: 'Afghanistan', value: 'AF' },
    { text: 'Ägypten', value: 'EG' },
    { text: 'Albanien', value: 'AL' },
    { text: 'Algerien', value: 'DZ' },
    { text: 'Andorra', value: 'AD' },
    { text: 'Angola', value: 'AO' },
    { text: 'Antigua und Barbuda', value: 'AG' },
    { text: 'Äquatorialguinea', value: 'GQ' },
    { text: 'Argentinien', value: 'AR' },
    { text: 'Armenien', value: 'AM' },
    { text: 'Aserbaidschan', value: 'AZ' },
    { text: 'Äthiopien', value: 'ET' },
    { text: 'Australien', value: 'AU' },
    { text: 'Bahamas', value: 'BS' },
    { text: 'Bahrain', value: 'BH' },
    { text: 'Bangladesch', value: 'BD' },
    { text: 'Barbados', value: 'BB' },
    { text: 'Belarus', value: 'BY' },
    { text: 'Belgien', value: 'BE' },
    { text: 'Belize', value: 'BZ' },
    { text: 'Benin', value: 'BJ' },
    { text: 'Bhutan', value: 'BT' },
    { text: 'Bolivien', value: 'BO' },
    { text: 'Bosnien und Herzegowina', value: 'BA' },
    { text: 'Botswana', value: 'BW' },
    { text: 'Brasilien', value: 'BR' },
    { text: 'Brunei', value: 'BN' },
    { text: 'Bulgarien', value: 'BG' },
    { text: 'Burkina Faso', value: 'BF' },
    { text: 'Burundi', value: 'BI' },
    { text: 'Chile', value: 'CL' },
    { text: 'Volksrepublik China', value: 'CN' },
    { text: 'Costa Rica', value: 'CR' },
    { text: 'Dänemark', value: 'DK' },
    { text: 'Dominica', value: 'DM' },
    { text: 'Dominikanische Republik', value: 'DO' },
    { text: 'Dschibuti', value: 'DJ' },
    { text: 'Ecuador', value: 'EC' },
    { text: 'Elfenbeinküste', value: 'CI' },
    { text: 'El Salvador', value: 'SV' },
    { text: 'Eritrea', value: 'ER' },
    { text: 'Estland', value: 'EE' },
    { text: 'Eswatini', value: 'SZ' },
    { text: 'Fidschi', value: 'FJ' },
    { text: 'Finnland', value: 'FI' },
    { text: 'Frankreich', value: 'FR' },
    { text: 'Gabun', value: 'GA' },
    { text: 'Gambia', value: 'GM' },
    { text: 'Georgien', value: 'GE' },
    { text: 'Ghana', value: 'GH' },
    { text: 'Grenada', value: 'GD' },
    { text: 'Griechenland', value: 'GR' },
    { text: 'Guatemala', value: 'GT' },
    { text: 'Guinea', value: 'GN' },
    { text: 'Guinea-Bissau', value: 'GW' },
    { text: 'Guyana', value: 'GY' },
    { text: 'Haiti', value: 'HT' },
    { text: 'Honduras', value: 'HN' },
    { text: 'Indien', value: 'IN' },
    { text: 'Indonesien', value: 'ID' },
    { text: 'Irak', value: 'IQ' },
    { text: 'Iran', value: 'IR' },
    { text: 'Irland', value: 'IE' },
    { text: 'Island', value: 'IS' },
    { text: 'Israel', value: 'IL' },
    { text: 'Italien', value: 'IT' },
    { text: 'Jamaika', value: 'JM' },
    { text: 'Japan', value: 'JP' },
    { text: 'Jemen', value: 'YE' },
    { text: 'Jordanien', value: 'JO' },
    { text: 'Kambodscha', value: 'KH' },
    { text: 'Kamerun', value: 'CM' },
    { text: 'Kanada', value: 'CA' },
    { text: 'Kap Verde', value: 'CV' },
    { text: 'Kasachstan', value: 'KZ' },
    { text: 'Katar', value: 'QA' },
    { text: 'Kenia', value: 'KE' },
    { text: 'Kirgisistan', value: 'KG' },
    { text: 'Kiribati', value: 'KI' },
    { text: 'Kolumbien', value: 'CO' },
    { text: 'Komoren', value: 'KM' },
    { text: 'Kongo, Demokratische Republik', value: 'CD' },
    { text: 'Kongo, Republik', value: 'CG' },
    { text: 'Korea, Nord', value: 'KP' },
    { text: 'Korea, Süd', value: 'KR' },
    { text: 'Kroatien', value: 'HR' },
    { text: 'Kuba', value: 'CU' },
    { text: 'Kuwait', value: 'KW' },
    { text: 'Laos', value: 'LA' },
    { text: 'Lesotho', value: 'LS' },
    { text: 'Lettland', value: 'LV' },
    { text: 'Libanon', value: 'LB' },
    { text: 'Liberia', value: 'LR' },
    { text: 'Libyen', value: 'LY' },
    { text: 'Litauen', value: 'LT' },
    { text: 'Luxemburg', value: 'LU' },
    { text: 'Madagaskar', value: 'MG' },
    { text: 'Malawi', value: 'MW' },
    { text: 'Malaysia', value: 'MY' },
    { text: 'Malediven', value: 'MV' },
    { text: 'Mali', value: 'ML' },
    { text: 'Malta', value: 'MT' },
    { text: 'Marokko', value: 'MA' },
    { text: 'Marshallinseln', value: 'MH' },
    { text: 'Mauretanien', value: 'MR' },
    { text: 'Mauritius', value: 'MU' },
    { text: 'Mexiko', value: 'MX' },
    { text: 'Mikronesien', value: 'FM' },
    { text: 'Moldau', value: 'MD' },
    { text: 'Monaco', value: 'MC' },
    { text: 'Mongolei', value: 'MN' },
    { text: 'Montenegro', value: 'ME' },
    { text: 'Mosambik', value: 'MZ' },
    { text: 'Myanmar', value: 'MM' },
    { text: 'Namibia', value: 'NA' },
    { text: 'Nauru', value: 'NR' },
    { text: 'Nepal', value: 'NP' },
    { text: 'Neuseeland', value: 'NZ' },
    { text: 'Nicaragua', value: 'NI' },
    { text: 'Niederlande', value: 'NL' },
    { text: 'Niger', value: 'NE' },
    { text: 'Nigeria', value: 'NG' },
    { text: 'Nordmazedonien', value: 'MK' },
    { text: 'Norwegen', value: 'NO' },
    { text: 'Oman', value: 'OM' },
    { text: 'Osttimor', value: 'TL' },
    { text: 'Pakistan', value: 'PK' },
    { text: 'Palau', value: 'PW' },
    { text: 'Panama', value: 'PA' },
    { text: 'Papua-Neuguinea', value: 'PG' },
    { text: 'Paraguay', value: 'PY' },
    { text: 'Peru', value: 'PE' },
    { text: 'Philippinen', value: 'PH' },
    { text: 'Polen', value: 'PL' },
    { text: 'Portugal', value: 'PT' },
    { text: 'Ruanda', value: 'RW' },
    { text: 'Rumänien', value: 'RO' },
    { text: 'Russland', value: 'RU' },
    { text: 'Salomonen', value: 'SB' },
    { text: 'Sambia', value: 'ZM' },
    { text: 'Samoa', value: 'WS' },
    { text: 'San Marino', value: 'SM' },
    { text: 'São Tomé und Príncipe', value: 'ST' },
    { text: 'Saudi-Arabien', value: 'SA' },
    { text: 'Schweden', value: 'SE' },
    { text: 'Senegal', value: 'SN' },
    { text: 'Serbien', value: 'RS' },
    { text: 'Seychellen', value: 'SC' },
    { text: 'Sierra Leone', value: 'SL' },
    { text: 'Simbabwe', value: 'ZW' },
    { text: 'Singapur', value: 'SG' },
    { text: 'Slowakei', value: 'SK' },
    { text: 'Slowenien', value: 'SI' },
    { text: 'Somalia', value: 'SO' },
    { text: 'Spanien', value: 'ES' },
    { text: 'Sri Lanka', value: 'LK' },
    { text: 'St. Kitts und Nevis', value: 'KN' },
    { text: 'St. Lucia', value: 'LC' },
    { text: 'St. Vincent und die Grenadinen', value: 'VC' },
    { text: 'Südafrika', value: 'ZA' },
    { text: 'Sudan', value: 'SD' },
    { text: 'Südsudan', value: 'SS' },
    { text: 'Suriname', value: 'SR' },
    { text: 'Syrien', value: 'SY' },
    { text: 'Tadschikistan', value: 'TJ' },
    { text: 'Tansania', value: 'TZ' },
    { text: 'Thailand', value: 'TH' },
    { text: 'Togo', value: 'TG' },
    { text: 'Tonga', value: 'TO' },
    { text: 'Trinidad und Tobago', value: 'TT' },
    { text: 'Tschad', value: 'TD' },
    { text: 'Tschechien', value: 'CZ' },
    { text: 'Tunesien', value: 'TN' },
    { text: 'Türkei', value: 'TR' },
    { text: 'Turkmenistan', value: 'TM' },
    { text: 'Tuvalu', value: 'TV' },
    { text: 'Uganda', value: 'UG' },
    { text: 'Ukraine', value: 'UA' },
    { text: 'Ungarn', value: 'HU' },
    { text: 'Uruguay', value: 'UY' },
    { text: 'Usbekistan', value: 'UZ' },
    { text: 'Vanuatu', value: 'VU' },
    { text: 'Venezuela', value: 'VE' },
    { text: 'Vereinigte Arabische Emirate', value: 'AE' },
    { text: 'Vereinigte Staaten', value: 'US' },
    { text: 'Vereinigtes Königreich', value: 'GB' },
    { text: 'Vietnam', value: 'VN' },
    { text: 'Zentralafrikanische Republik', value: 'CF' },
    { text: 'Zypern', value: 'CY' },
  ],
  fr: [
    { value: 'CH', text: 'Suisse' },
    { value: 'DE', text: 'Allemagne' },
    { value: 'AT', text: 'Autriche' },
    { value: 'LI', text: 'Liechtenstein' },
    { value: 'AF', text: 'Afghanistan' },
    { value: 'ZA', text: 'Afrique du Sud' },
    { value: 'AL', text: 'Albanie' },
    { value: 'DZ', text: 'Algérie' },
    { value: 'AD', text: 'Andorre' },
    { value: 'AO', text: 'Angola' },
    { value: 'AG', text: 'Antigua-et-Barbuda' },
    { value: 'SA', text: 'Arabie saoudite' },
    { value: 'AR', text: 'Argentine' },
    { value: 'AM', text: 'Arménie' },
    { value: 'AU', text: 'Australie' },
    { value: 'AZ', text: 'Azerbaïdjan' },
    { value: 'BS', text: 'Bahamas' },
    { value: 'BH', text: 'Bahreïn' },
    { value: 'BD', text: 'Bangladesh' },
    { value: 'BB', text: 'Barbade' },
    { value: 'BY', text: 'Biélorussie' },
    { value: 'BE', text: 'Belgique' },
    { value: 'BZ', text: 'Belize' },
    { value: 'BJ', text: 'Bénin' },
    { value: 'BT', text: 'Bhoutan' },
    { value: 'BO', text: 'Bolivie' },
    { value: 'BA', text: 'Bosnie-Herzégovine' },
    { value: 'BW', text: 'Botswana' },
    { value: 'BR', text: 'Brésil' },
    { value: 'BN', text: 'Brunei' },
    { value: 'BG', text: 'Bulgarie' },
    { value: 'BF', text: 'Burkina Faso' },
    { value: 'BI', text: 'Burundi' },
    { value: 'KH', text: 'Cambodge' },
    { value: 'CM', text: 'Cameroun' },
    { value: 'CA', text: 'Canada' },
    { value: 'CV', text: 'Cap-Vert' },
    { value: 'CF', text: 'République centrafricaine' },
    { value: 'CL', text: 'Chili' },
    { value: 'CN', text: 'Chine' },
    { value: 'CY', text: 'Chypre (pays)' },
    { value: 'CO', text: 'Colombie' },
    { value: 'KM', text: 'Comores' },
    { value: 'CG', text: 'République du Congo' },
    { value: 'CD', text: 'République démocratique du Congo' },
    { value: 'KR', text: 'Corée du Sud' },
    { value: 'KP', text: 'Corée du Nord' },
    { value: 'CR', text: 'Costa Rica' },
    { value: 'CI', text: "Côte d'Ivoire" },
    { value: 'HR', text: 'Croatie' },
    { value: 'CU', text: 'Cuba' },
    { value: 'DK', text: 'Danemark' },
    { value: 'DJ', text: 'Djibouti' },
    { value: 'DO', text: 'République dominicaine' },
    { value: 'DM', text: 'Dominique' },
    { value: 'EG', text: 'Égypte' },
    { value: 'SV', text: 'Salvador' },
    { value: 'AE', text: 'Émirats arabes unis' },
    { value: 'EC', text: 'Équateur' },
    { value: 'ER', text: 'Érythrée' },
    { value: 'ES', text: 'Espagne' },
    { value: 'EE', text: 'Estonie' },
    { value: 'US', text: 'États-Unis' },
    { value: 'ET', text: 'Éthiopie' },
    { value: 'FJ', text: 'Fidji' },
    { value: 'FI', text: 'Finlande' },
    { value: 'FR', text: 'France' },
    { value: 'GA', text: 'Gabon' },
    { value: 'GM', text: 'Gambie' },
    { value: 'GE', text: 'Géorgie' },
    { value: 'GH', text: 'Ghana' },
    { value: 'GR', text: 'Grèce' },
    { value: 'GD', text: 'Grenade' },
    { value: 'GT', text: 'Guatemala' },
    { value: 'GN', text: 'Guinée' },
    { value: 'GW', text: 'Guinée-Bissau' },
    { value: 'GQ', text: 'Guinée équatoriale' },
    { value: 'GY', text: 'Guyana' },
    { value: 'HT', text: 'Haïti' },
    { value: 'HN', text: 'Honduras' },
    { value: 'HU', text: 'Hongrie' },
    { value: 'IN', text: 'Inde' },
    { value: 'ID', text: 'Indonésie' },
    { value: 'IR', text: 'Iran' },
    { value: 'IQ', text: 'Irak' },
    { value: 'IE', text: 'Irlande' },
    { value: 'IS', text: 'Islande' },
    { value: 'IL', text: 'Israël' },
    { value: 'IT', text: 'Italie' },
    { value: 'JM', text: 'Jamaïque' },
    { value: 'JP', text: 'Japon' },
    { value: 'JO', text: 'Jordanie' },
    { value: 'KZ', text: 'Kazakhstan' },
    { value: 'KE', text: 'Kenya' },
    { value: 'KG', text: 'Kirghizistan' },
    { value: 'KI', text: 'Kiribati' },
    { value: 'KW', text: 'Koweït' },
    { value: 'LA', text: 'Laos' },
    { value: 'LS', text: 'Lesotho' },
    { value: 'LV', text: 'Lettonie' },
    { value: 'LB', text: 'Liban' },
    { value: 'LR', text: 'Liberia' },
    { value: 'LY', text: 'Libye' },
    { value: 'LT', text: 'Lituanie' },
    { value: 'LU', text: 'Luxembourg' },
    { value: 'MK', text: 'Macédoine du Nord' },
    { value: 'MG', text: 'Madagascar' },
    { value: 'MY', text: 'Malaisie' },
    { value: 'MW', text: 'Malawi' },
    { value: 'MV', text: 'Maldives' },
    { value: 'ML', text: 'Mali' },
    { value: 'MT', text: 'Malte' },
    { value: 'MA', text: 'Maroc' },
    { value: 'MH', text: 'Îles Marshall' },
    { value: 'MU', text: 'Maurice' },
    { value: 'MR', text: 'Mauritanie' },
    { value: 'MX', text: 'Mexique' },
    { value: 'FM', text: 'États fédérés de Micronésie' },
    { value: 'MD', text: 'Moldavie' },
    { value: 'MC', text: 'Monaco' },
    { value: 'MN', text: 'Mongolie' },
    { value: 'ME', text: 'Monténégro' },
    { value: 'MZ', text: 'Mozambique' },
    { value: 'MM', text: 'Birmanie' },
    { value: 'NA', text: 'Namibie' },
    { value: 'NR', text: 'Nauru' },
    { value: 'NP', text: 'Népal' },
    { value: 'NI', text: 'Nicaragua' },
    { value: 'NE', text: 'Niger' },
    { value: 'NG', text: 'Nigeria' },
    { value: 'NO', text: 'Norvège' },
    { value: 'NZ', text: 'Nouvelle-Zélande' },
    { value: 'OM', text: 'Oman' },
    { value: 'UG', text: 'Ouganda' },
    { value: 'UZ', text: 'Ouzbékistan' },
    { value: 'PK', text: 'Pakistan' },
    { value: 'PW', text: 'Palaos' },
    { value: 'PA', text: 'Panama' },
    { value: 'PG', text: 'Papouasie-Nouvelle-Guinée' },
    { value: 'PY', text: 'Paraguay' },
    { value: 'NL', text: 'Pays-Bas' },
    { value: 'PE', text: 'Pérou' },
    { value: 'PH', text: 'Philippines' },
    { value: 'PL', text: 'Pologne' },
    { value: 'PT', text: 'Portugal' },
    { value: 'QA', text: 'Qatar' },
    { value: 'RO', text: 'Roumanie' },
    { value: 'GB', text: 'Royaume-Uni' },
    { value: 'RU', text: 'Russie' },
    { value: 'RW', text: 'Rwanda' },
    { value: 'KN', text: 'Saint-Christophe-et-Niévès' },
    { value: 'SM', text: 'Saint-Marin' },
    { value: 'VC', text: 'Saint-Vincent-et-les-Grenadines' },
    { value: 'LC', text: 'Sainte-Lucie' },
    { value: 'SB', text: 'Îles Salomon' },
    { value: 'WS', text: 'Samoa' },
    { value: 'ST', text: 'Sao Tomé-et-Principe' },
    { value: 'SN', text: 'Sénégal' },
    { value: 'RS', text: 'Serbie' },
    { value: 'SC', text: 'Seychelles' },
    { value: 'SL', text: 'Sierra Leone' },
    { value: 'SG', text: 'Singapour' },
    { value: 'SK', text: 'Slovaquie' },
    { value: 'SI', text: 'Slovénie' },
    { value: 'SO', text: 'Somalie' },
    { value: 'SD', text: 'Soudan' },
    { value: 'SS', text: 'Soudan du Sud' },
    { value: 'LK', text: 'Sri Lanka' },
    { value: 'SE', text: 'Suède' },

    { value: 'SR', text: 'Suriname' },
    { value: 'SZ', text: 'Eswatini' },
    { value: 'SY', text: 'Syrie' },
    { value: 'TJ', text: 'Tadjikistan' },
    { value: 'TZ', text: 'Tanzanie' },
    { value: 'TD', text: 'Tchad' },
    { value: 'CZ', text: 'Tchéquie' },
    { value: 'TH', text: 'Thaïlande' },
    { value: 'TL', text: 'Timor oriental' },
    { value: 'TG', text: 'Togo' },
    { value: 'TO', text: 'Tonga' },
    { value: 'TT', text: 'Trinité-et-Tobago' },
    { value: 'TN', text: 'Tunisie' },
    { value: 'TM', text: 'Turkménistan' },
    { value: 'TR', text: 'Turquie' },
    { value: 'TV', text: 'Tuvalu' },
    { value: 'UA', text: 'Ukraine' },
    { value: 'UY', text: 'Uruguay' },
    { value: 'VU', text: 'Vanuatu' },
    { value: 'VE', text: 'Venezuela' },
    { value: 'VN', text: 'Viêt Nam' },
    { value: 'YE', text: 'Yémen' },
    { value: 'ZM', text: 'Zambie' },
    { value: 'ZW', text: 'Zimbabwe' },
  ],
  it: [
    { value: 'CH', text: 'Svizzera' },
    { value: 'DE', text: 'Germania' },
    { value: 'AT', text: 'Austria' },
    { value: 'LI', text: 'Liechtenstein' },
    { value: 'AF', text: 'Afghanistan' },
    { value: 'AL', text: 'Albania' },
    { value: 'DZ', text: 'Algeria' },
    { value: 'AD', text: 'Andorra' },
    { value: 'AO', text: 'Angola' },
    { value: 'AG', text: 'Antigua e Barbuda' },
    { value: 'SA', text: 'Arabia Saudita' },
    { value: 'AR', text: 'Argentina' },
    { value: 'AM', text: 'Armenia' },
    { value: 'AU', text: 'Australia' },
    { value: 'AZ', text: 'Azerbaigian' },
    { value: 'BS', text: 'Bahamas' },
    { value: 'BH', text: 'Bahrein' },
    { value: 'BD', text: 'Bangladesh' },
    { value: 'BB', text: 'Barbados' },
    { value: 'BE', text: 'Belgio' },
    { value: 'BZ', text: 'Belize' },
    { value: 'BJ', text: 'Benin' },
    { value: 'BT', text: 'Bhutan' },
    { value: 'BY', text: 'Bielorussia' },
    { value: 'MM', text: 'Birmania' },
    { value: 'BO', text: 'Bolivia' },
    { value: 'BA', text: 'Bosnia ed Erzegovina' },
    { value: 'BW', text: 'Botswana' },
    { value: 'BR', text: 'Brasile' },
    { value: 'BN', text: 'Brunei' },
    { value: 'BG', text: 'Bulgaria' },
    { value: 'BF', text: 'Burkina Faso' },
    { value: 'BI', text: 'Burundi' },
    { value: 'KH', text: 'Cambogia' },
    { value: 'CM', text: 'Camerun' },
    { value: 'CA', text: 'Canada' },
    { value: 'CV', text: 'Capo Verde' },
    { value: 'TD', text: 'Ciad' },
    { value: 'CL', text: 'Cile' },
    { value: 'CN', text: 'Cina' },
    { value: 'CY', text: 'Cipro' },
    { value: 'CO', text: 'Colombia' },
    { value: 'KM', text: 'Comore' },
    { value: 'KP', text: 'Corea del Nord' },
    { value: 'KR', text: 'Corea del Sud' },
    { value: 'CI', text: "Costa d'Avorio" },
    { value: 'CR', text: 'Costa Rica' },
    { value: 'HR', text: 'Croazia' },
    { value: 'CU', text: 'Cuba' },
    { value: 'DK', text: 'Danimarca' },
    { value: 'DM', text: 'Dominica' },
    { value: 'EC', text: 'Ecuador' },
    { value: 'EG', text: 'Egitto' },
    { value: 'SV', text: 'El Salvador' },
    { value: 'AE', text: 'Emirati Arabi Uniti' },
    { value: 'ER', text: 'Eritrea' },
    { value: 'EE', text: 'Estonia' },
    { value: 'ET', text: 'Etiopia' },
    { value: 'FJ', text: 'Figi' },
    { value: 'PH', text: 'Filippine' },
    { value: 'FI', text: 'Finlandia' },
    { value: 'FR', text: 'Francia' },
    { value: 'GA', text: 'Gabon' },
    { value: 'GM', text: 'Gambia' },
    { value: 'GE', text: 'Georgia' },
    { value: 'GH', text: 'Ghana' },
    { value: 'JM', text: 'Giamaica' },
    { value: 'JP', text: 'Giappone' },
    { value: 'DJ', text: 'Gibuti' },
    { value: 'JO', text: 'Giordania' },
    { value: 'GR', text: 'Grecia' },
    { value: 'GD', text: 'Grenada' },
    { value: 'GT', text: 'Guatemala' },
    { value: 'GN', text: 'Guinea' },
    { value: 'GW', text: 'Guinea-Bissau' },
    { value: 'GQ', text: 'Guinea Equatoriale' },
    { value: 'GY', text: 'Guyana' },
    { value: 'HT', text: 'Haiti' },
    { value: 'HN', text: 'Honduras' },
    { value: 'IN', text: 'India' },
    { value: 'ID', text: 'Indonesia' },
    { value: 'IR', text: 'Iran' },
    { value: 'IQ', text: 'Iraq' },
    { value: 'IE', text: 'Irlanda' },
    { value: 'IS', text: 'Islanda' },
    { value: 'MH', text: 'Isole Marshall' },
    { value: 'SB', text: 'Isole Salomone' },
    { value: 'IL', text: 'Israele' },
    { value: 'IT', text: 'Italia' },
    { value: 'KZ', text: 'Kazakistan' },
    { value: 'KE', text: 'Kenya' },
    { value: 'KG', text: 'Kirghizistan' },
    { value: 'KI', text: 'Kiribati' },
    { value: 'KW', text: 'Kuwait' },
    { value: 'LA', text: 'Laos' },
    { value: 'LS', text: 'Lesotho' },
    { value: 'LV', text: 'Lettonia' },
    { value: 'LB', text: 'Libano' },
    { value: 'LR', text: 'Liberia' },
    { value: 'LY', text: 'Libia' },
    { value: 'LT', text: 'Lituania' },
    { value: 'LU', text: 'Lussemburgo' },
    { value: 'MK', text: 'Macedonia del Nord' },
    { value: 'MG', text: 'Madagascar' },
    { value: 'MW', text: 'Malawi' },
    { value: 'MY', text: 'Malaysia' },
    { value: 'MV', text: 'Maldive' },
    { value: 'ML', text: 'Mali' },
    { value: 'MT', text: 'Malta' },
    { value: 'MA', text: 'Marocco' },
    { value: 'MR', text: 'Mauritania' },
    { value: 'MU', text: 'Mauritius' },
    { value: 'MX', text: 'Messico' },
    { value: 'FM', text: 'Micronesia' },
    { value: 'MD', text: 'Moldavia' },
    { value: 'MN', text: 'Mongolia' },
    { value: 'ME', text: 'Montenegro' },
    { value: 'MZ', text: 'Mozambico' },
    { value: 'NA', text: 'Namibia' },
    { value: 'NR', text: 'Nauru' },
    { value: 'NP', text: 'Nepal' },
    { value: 'NI', text: 'Nicaragua' },
    { value: 'NE', text: 'Niger' },
    { value: 'NG', text: 'Nigeria' },
    { value: 'NO', text: 'Norvegia' },
    { value: 'NZ', text: 'Nuova Zelanda' },
    { value: 'OM', text: 'Oman' },
    { value: 'NL', text: 'Paesi Bassi' },
    { value: 'PK', text: 'Pakistan' },
    { value: 'PW', text: 'Palau' },
    { value: 'PA', text: 'Panama' },
    { value: 'PG', text: 'Papua Nuova Guinea' },
    { value: 'PY', text: 'Paraguay' },
    { value: 'PE', text: 'Perù' },
    { value: 'PL', text: 'Polonia' },
    { value: 'PT', text: 'Portogallo' },
    { value: 'MC', text: 'Monaco' },
    { value: 'QA', text: 'Qatar' },
    { value: 'GB', text: 'Regno Unito' },
    { value: 'CD', text: 'RD del Congo' },
    { value: 'CZ', text: 'Rep. Ceca' },
    { value: 'CF', text: 'Rep. Centrafricana' },
    { value: 'CG', text: 'Rep. del Congo' },
    { value: 'DO', text: 'Rep. Dominicana' },
    { value: 'RO', text: 'Romania' },
    { value: 'RW', text: 'Ruanda' },
    { value: 'RU', text: 'Russia' },
    { value: 'KN', text: 'Saint Kitts e Nevis' },
    { value: 'LC', text: 'Saint Lucia' },
    { value: 'VC', text: 'Saint Vincent e Grenadine' },
    { value: 'WS', text: 'Samoa' },
    { value: 'SM', text: 'San Marino' },
    { value: 'ST', text: 'São Tomé e Príncipe' },
    { value: 'SN', text: 'Senegal' },
    { value: 'RS', text: 'Serbia' },
    { value: 'SC', text: 'Seychelles' },
    { value: 'SL', text: 'Sierra Leone' },
    { value: 'SG', text: 'Singapore' },
    { value: 'SY', text: 'Siria' },
    { value: 'SK', text: 'Slovacchia' },
    { value: 'SI', text: 'Slovenia' },
    { value: 'SO', text: 'Somalia' },
    { value: 'ES', text: 'Spagna' },
    { value: 'LK', text: 'Sri Lanka' },
    { value: 'US', text: 'Stati Uniti' },
    { value: 'ZA', text: 'Sudafrica' },
    { value: 'SD', text: 'Sudan' },
    { value: 'SS', text: 'Sudan del Sud' },
    { value: 'SR', text: 'Suriname' },
    { value: 'SE', text: 'Svezia' },
    { value: 'SZ', text: 'eSwatini' },
    { value: 'TJ', text: 'Tagikistan' },
    { value: 'TZ', text: 'Tanzania' },
    { value: 'TH', text: 'Thailandia' },
    { value: 'TL', text: 'Timor Est' },
    { value: 'TG', text: 'Togo' },
    { value: 'TO', text: 'Tonga' },
    { value: 'TT', text: 'Trinidad e Tobago' },
    { value: 'TN', text: 'Tunisia' },
    { value: 'TR', text: 'Turchia' },
    { value: 'TM', text: 'Turkmenistan' },
    { value: 'TV', text: 'Tuvalu' },
    { value: 'UA', text: 'Ucraina' },
    { value: 'UG', text: 'Uganda' },
    { value: 'HU', text: 'Ungheria' },
    { value: 'UY', text: 'Uruguay' },
    { value: 'UZ', text: 'Uzbekistan' },
    { value: 'VU', text: 'Vanuatu' },
    { value: 'VE', text: 'Venezuela' },
    { value: 'VN', text: 'Vietnam' },
    { value: 'YE', text: 'Yemen' },
    { value: 'ZM', text: 'Zambia' },
    { value: 'ZW', text: 'Zimbabwe' },
  ],
}
